export default __webpack_public_path__ + "static/media/Maintenance Platforms.a209f0ce.jpg";